var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.907,
    height: 37.784,
    viewBox: "0 0 40.907 37.784",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cart",
    transform: "translate(-3.382 -4.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M14.284,30.486a2.361,2.361,0,1,1-2.361-2.361,2.361,2.361,0,0,1,2.361,2.361Z",
    transform: "translate(2.466 9.43)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M30.069,30.486a2.361,2.361,0,1,1-2.361-2.361,2.361,2.361,0,0,1,2.361,2.361Z",
    transform: "translate(8.765 9.43)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M44.274,11.212a.578.578,0,0,0-.512-.413L11.724,7.7a.986.986,0,0,1-.738-.462,10.017,10.017,0,0,0-1.2-1.83c-.757-.925-2.184-.9-4.8-.915a1.433,1.433,0,0,0-1.6,1.387A1.406,1.406,0,0,0,4.917,7.267a13.07,13.07,0,0,1,2.558.187c.462.138.836.9.974,1.554a.036.036,0,0,0,.01.03c.02.118.2,1,.2,1.013l3.935,20.815a7.65,7.65,0,0,0,1.426,3.512,3.926,3.926,0,0,0,3.236,1.594H40.527a1.4,1.4,0,0,0,1.417-1.318,1.371,1.371,0,0,0-1.377-1.436H17.233a1.143,1.143,0,0,1-.816-.275,4.414,4.414,0,0,1-1.131-2.558l-.423-2.331a.054.054,0,0,1,.039-.059L42.218,23.37a.575.575,0,0,0,.482-.512l1.574-11.391A.561.561,0,0,0,44.274,11.212Z",
    transform: "translate(0 0)",
    fill: "#efefef"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.c3fac856.svg";
export { ForwardRef as ReactComponent };